import React, { Fragment } from 'react';

import uuid from 'uuid';

import { Icon, Tooltip } from 'evergreen-ui';
import {
	StyledCardsDevices,
	RenderColorSVGDesktop,
	RenderColorSVGMobile,
	RenderStyleSVG,
} from './style/StyledCards';

import { ReactComponent as Computer } from './images/computer.svg';
import { ReactComponent as Phone } from './images/phone.svg';
import { ReactComponent as Google } from '../../../../containers/customer/ShowReport/images/google.svg';
import { ReactComponent as Clicks } from './images/clicks.svg';
import { ReactComponent as Impressions } from './images/impressions.svg';
import { ReactComponent as Ranking } from './images/ranking.svg';
import { ReactComponent as CTR } from './images/ctr.svg';

import { SelectColor } from '../../../../services/reports';

const Cards = ({
	data, alias, channel, title,
}) => {
	const renderImage = (image) => {
		switch (image) {
			case 'GoogleAdsMetrics':
				return <Google width={24} height={24} className="google mr-2" />;
			case 'Cliques':
				return <Clicks width={24} height={24} className="clicks mr-2" fill="#1877F2" />;
			case 'Impressões':
				return <Impressions width={24} height={24} className="impressions mr-2" />;
			case 'Alcance':
				return <Ranking width={24} height={24} className="ranking mr-2" />;
			case 'CTR':
				return <CTR width={24} height={24} className="ctr mr-2" />;
			default:
				return '';
		}
	};

	const renderToolTip = (valueTitle) => {
		switch (valueTitle) {
			case 'Cliques':
				return (
					<Tooltip content="Quando alguém clica no seu anúncio ele é contabilizado aqui.">
						<Icon icon="info-sign" color="#43BCCD" />
					</Tooltip>
				);
			case 'Impressões':
				return (
					<Tooltip content="É a quantidade de vezes que seu anúncio é exibido no canal. Vale lembrar que o mesmo usuário pode visualizar mais de uma vez no feed de notícias, contabilizando mais impressões.">
						<Icon icon="info-sign" color="#43BCCD" />
					</Tooltip>
				);
			case 'Alcance':
				return (
					<Tooltip content="É o número de pessoas que viram sua publicação. ">
						<Icon icon="info-sign" color="#43BCCD" />
					</Tooltip>
				);
			case 'CTR':
				return (
					<Tooltip content="É a sua taxa de cliques, ou seja, a porcentagem de pessoas que clicaram no seu anúncio depois de vê-lo. O cálculo é feito dividindo o número de pessoas que clicaram depois de ver o anúncio, pelo número total de impressões recebidas.">
						<Icon icon="info-sign" color="#43BCCD" />
					</Tooltip>
				);
			default:
				return null;
		}
	};

	if (alias === 'cards_go_ads_metrics' || alias === 'cards_face_metrics' || alias === 'cards_insta_metrics') {
		return (
			<Fragment>
				<h2 className="title-cards mt-3">{title}</h2>

				<ul>
					{data.map(chart => (
						<li key={uuid.v4()}>
							<div className="top">
								<RenderStyleSVG channel={channel}>
									{renderImage(chart.alias)}
								</RenderStyleSVG>
								<h5 className="mr-2" style={{ marginLeft: '5px' }}>{chart.title}</h5>

								{renderToolTip(chart.title)}
							</div>

							<div className="content">
								<p>{chart.value}</p>
							</div>
						</li>
					))}
				</ul>
			</Fragment>
		);
	}

	if (alias === 'card_go_devices' || alias === 'card_face_device_click' || 'card_face_device_impression' || alias === 'card_insta_device_click' || 'card_insta_device_impression') { 
		return (
			<StyledCardsDevices>
				<div className="container-devices">
					{
						data.map((element, indice) => (
							<Fragment key={uuid.v4()}>
								<div className={`element-${indice + 1}`}>
									{(element.title === 'Desktop') ? (
										<RenderColorSVGDesktop
											color={SelectColor(channel, element.title, element.alias)}
										>
											<Computer width={75} height={70} />
										</RenderColorSVGDesktop>
									)
										: (
											<RenderColorSVGMobile
												color={SelectColor(channel, element.title, element.alias)}
											>
												<Phone width={75} height={70} />
											</RenderColorSVGMobile>
										)
									}
									<div className="content-devices">
										<h5>{element.value}</h5>
										<p>{element.text}</p>
									</div>
								</div>
							</Fragment>
						))
					}
				</div>
			</StyledCardsDevices>
		);
	}

	return null;
};

export default Cards;
